import styled from "@emotion/styled";
import {Permissions} from "api/auth";
import {DropDown} from "components/DropDown";
import Loading from "components/Loading";
import {H2} from "components/elements";
import {useEffect, useState} from "react";
import NewQuote from ".";
import {useAuth, usePermissions} from "hooks/auth";

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 10vh 30vw 10vh;
`;

export default function HabStateCheck() {
  const {assignedStates} = useAuth();
  const permissons = usePermissions();

  const onlyNJ = assignedStates.length === 1 && assignedStates[0] === "NJ";

  const [NJSelected, setNJSelected] = useState(false);
  const [otherThanNJSelected, setOtherThanNJSelected] = useState(false);

  useEffect(() => {
    if (otherThanNJSelected) {
      process.env.REACT_APP_NEW_HABITATIONAL_QUOTE_LINK
        ? (window.location.href =
            process.env.REACT_APP_NEW_HABITATIONAL_QUOTE_LINK)
        : window.location.reload();
    }
  }, [otherThanNJSelected]);

  return permissons.includes(Permissions.CAN_QUOTE_MAJESCO_ALL_STATES) ||
    onlyNJ ||
    NJSelected ? (
    <NewQuote quoteType={"HAB"} />
  ) : otherThanNJSelected ? (
    <Loading>
      <H2>Just a sec while we redirect you...</H2>
    </Loading>
  ) : (
    <StyledDiv>
      <H2>Where is the risk located?</H2>
      <DropDown
        label={"Select a state"}
        value={"selectedAgencyId"}
        options={assignedStates.map((state) => ({
          title: state,
          value: state,
        }))}
        onChange={(value) => {
          if (value === "NJ") {
            setNJSelected(true);
            setOtherThanNJSelected(false);
          } else {
            setOtherThanNJSelected(true);
            setNJSelected(false);
          }
        }}
      />
    </StyledDiv>
  );
}
